module.exports = __webpack_public_path__ + "img/integratedLogo5.516fcceb.png";